import axios from 'axios';

const opensearchEndpoint = process.env.VUE_APP_OPENSEARCH_URL;
const wordsIndexName = localStorage.getItem('wordsIndex');
const updatesIndexName = 'updates';
const gamesIndexName = localStorage.getItem('gamesIndex');
const sentencesIndexName = localStorage.getItem('sentencesIndex');
const DEFAULT_SIZE = 40000

// Encode the credentials in Base64
const credentials = Buffer.from(`admin:${process.env.VUE_APP_OPENSEARCH_PASSWORD}`).toString('base64');
const authHeader = `Basic ${credentials}`;

export const wordService = {
    getWords,
    getGameWords,
    getSavedWords,
    getRandomWords,
    getKnownWords,
    getGroupWords,
    getSentences,
};

const COURSE_ID = localStorage.getItem("courseNum");;

async function getWords(user) {
    let words = [];
    let updated;


    try {
        const apiUrl = `${opensearchEndpoint}/_cluster/health`;

        const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': authHeader,
                'Content-Type': 'application/json',
            },
            withCredentials: false,
        });

        const domainStatus = response.data;

        if (domainStatus) {
            updated = domainStatus.timestamp; // Adjust based on your OpenSearch data structure
        }
    } catch (error) {
        console.error('Error retrieving OpenSearch index information:', error);
        return words;
    }

    if (window.localStorage.getItem('wordsCacheEng')) {
        if (window.localStorage.getItem('wordsCacheEng') === updated) {
            if (window.localStorage.engWords) {
                words = JSON.parse(window.localStorage.engWords);
                console.log('GOT WORDS FROM LOCALSTORAGE');
                return words;
            }
        }
    }

    const query = {
        size: DEFAULT_SIZE,
        query: {
            match_all: {}, // Adjust the query as needed
        },
    };

    try {
        const apiUrl = `${opensearchEndpoint}/${wordsIndexName}/_search`;

        const response = await axios.post(apiUrl, query, {
            headers: {
                'Authorization': authHeader,
                'Content-Type': 'application/json',
            },
            withCredentials: false,
        });

        words = response.data.hits.hits.map(hit => Object.assign({}, hit._source, { objectID: hit._id })); // Adjust based on your OpenSearch data structure
    } catch (error) {
        console.error('Error retrieving data from OpenSearch:', error.response ? error.response.data : error.message);
        return words;
    }

    window.localStorage.setItem('engWords', JSON.stringify(words));

    if (user && user.known_words && user.known_words.length) {
        user.known_words.forEach(kw => {
            words = words.map(w => {
                if (kw.id === w.id) {
                    w.know = kw.score || 0;
                }
                return w;
            });
        });
    }

    window.localStorage.setItem('wordsCacheEng', updated);

    return words;
}

async function getGameWords(game_id) {
    let words = [];

    let query = {
        size: DEFAULT_SIZE,
        query: {
            match: {
                game_id: game_id,
            },
        },
    };

    try {
        const apiUrl = `${opensearchEndpoint}/${gamesIndexName}/_search`;

        const response = await axios.post(apiUrl, query, {
            headers: {
                'Authorization': authHeader,
                'Content-Type': 'application/json',
            },
            withCredentials: false,
        });

        words = response.data.hits.hits.map(hit => Object.assign({}, hit._source, { objectID: hit._id }))[0]; // Adjust based on your OpenSearch data structure
        console.log(words)
    } catch (error) {
        console.log('Error:', error)
        console.error('Error retrieving game words from OpenSearch:', error.response ? error.response.data : error.message);
        return null;
    }

    const results = Object.values(words).filter(element => element !== undefined && element !== '');
    query = {
        bool: {
            must: [
                {
                    terms: {id: results}
                }
            ]
        }
    }

    let test = [];
    try {
        const apiUrl = `${opensearchEndpoint}/${wordsIndexName}/_search`;

        const response = await axios.post(apiUrl, { size: DEFAULT_SIZE, query }, {
            headers: {
                'Authorization': authHeader,
                'Content-Type': 'application/json',
            },
            withCredentials: false,
        });

        test = response.data.hits.hits.map(hit => Object.assign({}, hit._source, { objectID: hit._id })); // Adjust based on your OpenSearch data structure
    } catch (error) {
        console.error('Error retrieving group words from OpenSearch:', error.response ? error.response.data : error.message);
    }

    return test;
}

async function getGroupWords(group_id) {
    let words = [];

    const query = {
        size: DEFAULT_SIZE,
        query: {
            query_string: {
                query: `group\\*: ${group_id}`
            },
        },
    }


    try {
        const apiUrl = `${opensearchEndpoint}/${wordsIndexName}/_search`;

        const response = await axios.post(apiUrl, query, {
            headers: {
                'Authorization': authHeader,
                'Content-Type': 'application/json',
            },
            withCredentials: false,
        });

        words = response.data.hits.hits.map(hit => Object.assign({}, hit._source, { objectID: hit._id })); // Adjust based on your OpenSearch data structure
    } catch (error) {
        console.error('Error retrieving group words from OpenSearch:', error.response ? error.response.data : error.message);
    }

    return words;
}

async function getSavedWords(user) {
    if (user && user.saved_words && user.saved_words.length) {
        const savedWords = user.saved_words
            .map(word => word.external_id);
        let saved = [];

        if (savedWords) {
            console.log(savedWords);
            if (window.localStorage.getItem('engWords')) {
                let words = await JSON.parse(window.localStorage.engWords);
                saved = words.filter(savedword => savedWords.includes(savedword.id));
            } else {
                let filters = savedWords
                    .filter(res => res)
                    .map(res => `id:${res}`)
                    .join(' OR ');

                try {
                    const apiUrl = `${opensearchEndpoint}/${wordsIndexName}/_search`;

                    const response = await axios.post(apiUrl, { size: DEFAULT_SIZE, query: { match_all: {} }, filters: filters }, {
                        headers: {
                            'Authorization': authHeader,
                            'Content-Type': 'application/json',
                        },
                        withCredentials: false,
                    });

                    saved = response.data.hits.hits.map(hit => Object.assign({}, hit._source, { objectID: hit._id })); // Adjust based on your OpenSearch data structure
                } catch (error) {
                    console.error('Error retrieving saved words from OpenSearch:', error.response ? error.response.data : error.message);
                }
            }

            saved.forEach(saved_word => {
                const kW = user.known_words.find(w => w.external_id === saved_word.id);
                if (kW) {
                    saved_word.know = kW.score || 0;
                }
            });

            console.log(saved);
        }

        return saved;
    }

    return [];
}

async function getKnownWords(user) {
    if (user && user.known_words && user.known_words.length) {
        const knownWords = user.known_words
            .filter(res => res.score > 0)
            .map(word => word.external_id);
        let saved = [];

        if (knownWords) {
            console.log(knownWords);
            if (window.localStorage.getItem('engWords')) {
                let words = await JSON.parse(window.localStorage.engWords);
                saved = words.filter(savedword => knownWords.includes(savedword.id));
            } else {
                let filters = knownWords
                    .filter(res => res)
                    .map(res => `id:${res}`)
                    .join(' OR ');

                try {
                    const apiUrl = `${opensearchEndpoint}/${wordsIndexName}/_search`;

                    const response = await axios.post(apiUrl, { size: DEFAULT_SIZE, query: { match_all: {} }, filters: filters }, {
                        headers: {
                            'Authorization': authHeader,
                            'Content-Type': 'application/json',
                        },
                        withCredentials: false,
                    });

                    saved = response.data.hits.hits.map(hit => Object.assign({}, hit._source, { objectID: hit._id })); // Adjust based on your OpenSearch data structure
                } catch (error) {
                    console.error('Error retrieving known words from OpenSearch:', error.response ? error.response.data : error.message);
                }
            }

            saved.forEach(saved_word => {
                const kW = user.known_words.find(w => w.external_id === saved_word.id);
                if (kW) {
                    saved_word.know = kW.score || 0;
                }
            });

            console.log(saved);
        }

        return saved;
    }

    return [];
}

function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
}

function getRandomLetter() {
    const alphabet = 'abcdefghijklmnoprstuvwy';
    const randomCharacter = alphabet[Math.floor(Math.random() * alphabet.length)];
    return randomCharacter;
}

async function getRandomWords(num) {
    let randomWords = [];
    const ranLetter = getRandomLetter();

    try {
        const apiUrl = `${opensearchEndpoint}/${wordsIndexName}/_search`;

        const response = await axios.post(apiUrl, { query: {match_phrase_prefix: {Eng: ranLetter}}, size: num }, {
            headers: {
                'Authorization': authHeader,
                'Content-Type': 'application/json',
            },
            withCredentials: false,
        });

        randomWords = response.data.hits.hits.map(hit => Object.assign({}, hit._source, { objectID: hit._id })); // Adjust based on your OpenSearch data structure
    } catch (error) {
        console.error('Error retrieving random words from OpenSearch:', error.response ? error.response.data : error.message);
    }

    console.log('LETTER:', ranLetter);
    console.log(randomWords);
    return randomWords;
}

async function getSentences(word) {
    const query = {
        match_phrase: {
            words: word
        }
    }
    console.log(query)
    return await postOS(sentencesIndexName, query)
}

async function postOS(index, query) {
    try {
        const apiUrl = `${opensearchEndpoint}/${index}/_search`;

        const response = await axios.post(apiUrl, {query, size: DEFAULT_SIZE}, {
            headers: {
                'Authorization': authHeader,
                'Content-Type': 'application/json',
            },
            withCredentials: false,
        });

        return response.data.hits.hits.map(hit => Object.assign({}, hit._source, { objectID: hit._id })); // Adjust based on your OpenSearch data structure
    } catch (error) {
        console.error('Error retrieving random words from OpenSearch:', error.response ? error.response.data : error.message);
        return null
    }
}


// WEBPACK FOOTER //
// ./src/services/wordService.js